export const PASSWORD_MAX_LENGTH = 72;

export const SUPPORT_CONTACT_URL = 'https://www.screeningeagle.com/en/contact-us';
export const DATA_PRIVACY_URL = 'https://www.screeningeagle.com/en/legal/data-privacy-policy';

export const CMS_NEWS_URL_PREFIX = 'https://www.screeningeagle.com/en/about-us/news/';
